import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService, 
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
      if (this.authService.getAuthStatusSnapshot().is_authenticated) {
        return true;
      } else {
        // If this is a registered user, but they are not authenticated, then redirect to the login page
        if (this.authService.isRegisteredUser()) {
          return this.router.parseUrl('/auth/login');
        }
        // Otherwise, redirect to the info page
        return this.router.parseUrl('/info');
      }

  }
  
}
